var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneIconYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78255 12.0303C2.6888 12.9491 2.32422 15.6762 2.32422 15.6762C2.32422 15.6762 5.0513 15.3116 5.97005 14.2178C6.48776 13.6053 6.48047 12.6647 5.90443 12.0959C5.621 11.8254 5.24766 11.6691 4.85605 11.657C4.46444 11.6449 4.08215 11.7778 3.78255 12.0303Z",
    stroke: "#A4780E",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.9403L7.0625 8.75278C7.45052 7.74612 7.93911 6.78116 8.52083 5.87258C9.37045 4.51413 10.5535 3.39563 11.9574 2.62348C13.3613 1.85132 14.9394 1.45118 16.5417 1.46112C16.5417 3.44445 15.9729 6.92987 12.1667 9.48195C11.2456 10.0644 10.2685 10.5529 9.25 10.9403Z",
    stroke: "#A4780E",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0638 8.75104H3.41797C3.41797 8.75104 3.81901 6.54167 4.8763 5.83438C6.05755 5.04687 8.52214 5.83438 8.52214 5.83438",
    stroke: "#A4780E",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.9349V14.5807C9.25 14.5807 11.4594 14.1797 12.1667 13.1224C12.9542 11.9411 12.1667 9.47656 12.1667 9.47656",
    stroke: "#A4780E",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIconYellow);
export default __webpack_public_path__ + "static/media/PlaneIconYellow.ad3a7bead3c93d3fd7152358330978f8.svg";
export { ForwardRef as ReactComponent };